import { render } from "./CreateProject.vue?vue&type=template&id=64a0c548&scoped=true"
import script from "./CreateProject.vue?vue&type=script&lang=js"
export * from "./CreateProject.vue?vue&type=script&lang=js"

import "./CreateProject.vue?vue&type=style&index=0&id=64a0c548&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a0c548"]])

export default __exports__